import {cache} from 'locache';

export const initCookieBar = () => {
  const COOKIE_BAR_CACHE_NAME = 'cookieBarClosed';
  const cookieBar = document.getElementsByClassName('cookie-bar')[0];
  if (!cookieBar) {
    return;
  }

  const closeButton = cookieBar.getElementsByClassName('cookie-bar__close')[0];
  if (!closeButton) {
    return;
  }

  closeButton.addEventListener('click', () => {
    Velocity(cookieBar, 'slideUp');
    cache(COOKIE_BAR_CACHE_NAME).set(true);
  });

  setTimeout(() => {
    const cookieBarClosed = cache(COOKIE_BAR_CACHE_NAME).get();
    if (cookieBarClosed) {
      return;
    }
    Velocity(cookieBar, 'slideDown');
  }, 250);
};
